import React, { useEffect, useState } from "react";

// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import 'react-tabs/style/react-tabs.css';

import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { TabsReportes } from "../../components/forms/TabsReportes";
import { useReportes } from "../../../hooks/reportes/useReportes";

export const Reportes = () => {
    const {listarReportesActivos,reportesActivos} = useReportes()

    useEffect(() => {
        (async () => {
            await listarReportesActivos()
        })()
    },[])

    return(
        <>
            <div className="containerScroll mt-3 relative top-0 bottom-0 left-0 right-0 contenedor-tabla w-full h-full overflow-hidden">
                <TabsReportes listaMenus={[...reportesActivos,{
                    codReporte: 1,
                    codigoReporte: "RP002",
                    nomReporte: "Reporte de kardex",
                    tituloReporte: "Reporte de kardex"
                }] || []}></TabsReportes>
            </div>
        </>
    )
};
